(function($) {
	
	var	$headerShare = $('.post-header .social-share');
	var	$shareFloating = $('.social-share.floating');
	var $footer = $('#footer');
	var shareThresholdBottom = $('#content').outerHeight() - 188 -70; // 188 - $headerShare.outerHeight() in vertical position, 70 - additional margin

	if ( $headerShare.length ) {
		$(window).scroll(function(event) {
			var scrollTop = $(window).scrollTop();
			var shareThreshold = $headerShare.offset().top + $headerShare.outerHeight();

			if ( scrollTop > shareThreshold && scrollTop < shareThresholdBottom ) {
				$shareFloating.addClass('on');
			} else {
				$shareFloating.removeClass('on');
			}
		});
	}else{
		$shareFloating.addClass('on');
	}

})(jQuery);